import { trainingTypes } from '../Constants'

export type TrainingType = typeof trainingTypes[keyof typeof trainingTypes]
export const TrainingTypes: TrainingType[] = Object.values(trainingTypes)
